import { render } from "./MenuPrincipal.vue?vue&type=template&id=2e377921"
import script from "./MenuPrincipal.vue?vue&type=script&lang=js"
export * from "./MenuPrincipal.vue?vue&type=script&lang=js"

import "./MenuPrincipal.vue?vue&type=style&index=0&id=2e377921&lang=css"
import "./MenuPrincipal.vue?vue&type=style&index=1&id=2e377921&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__